'use client'; // Error components must be Client Components

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errorPage');

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: 'sans-serif',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>{t('somethingWentWrong')}</h1>
      <p style={{ fontSize: '1.2rem', marginBottom: '2rem' }}>{t('sorry')}</p>
      <button
        onClick={() => reset()}
        style={{
          padding: '1rem 2rem',
          fontSize: '1rem',
          color: '#fff',
          backgroundColor: '#0070f3',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        {t('tryAgain')}
      </button>

      {process.env.NODE_ENV === 'development' && (
        <details style={{ marginTop: '2rem', width: '80%', maxWidth: '800px' }}>
          <summary style={{ cursor: 'pointer', opacity: 0.7 }}>{t('technicalDetails')}</summary>
          <pre
            style={{
              marginTop: '1rem',
              padding: '1rem',
              backgroundColor: '#f3f3f3',
              border: '1px solid #ddd',
              borderRadius: '5px',
              color: '#333',
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              textAlign: 'left',
            }}
          >
            {error?.stack || error.toString()}
          </pre>
        </details>
      )}
    </div>
  );
}
